import { HearthBeatLoader } from '@components/ui';
import React from 'react';
import { LoadingSC } from './loading.styled';

const Loading: React.FC = () => (
  <LoadingSC>
    <HearthBeatLoader loading size={'large'} />
    {/*  <img src={require('../../assets/gif/hilbi-loader.gif').default} alt="Loading" /> */}
  </LoadingSC>
);

export default Loading;
